import {updateBio} from "../api/userApi";

export function useUserActions({ setProfile, setMyAchievements }) {
  const handleUpdateBio = async (userId, newBio) => {
    try {
      await updateBio(userId, newBio); // userId ignored by backend now
      setProfile(prev => ({ ...prev, bio: newBio }));
      return true;
    } catch (err) {
      console.error("Failed to update bio:", err);
      return false;
    }
  };

  return { handleUpdateBio };

}
export default useUserActions;